
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import AIcon from '@/components/AIcon.vue'
import { DateTimeHelper } from '@/helper/dateTime'
import { useRouter } from '@/routing/router'

export default defineComponent({
  name: 'UserItem',
  components: {
    AButton,
    AIcon,
  },
  data() {
    return {
      isActive: false,
    }
  },
  props: {
    user: {
      type: Object,
      default: {},
    },
  },
  methods: {
    formatDateTime(date: string) {
      return DateTimeHelper.formatDateTimeFromString(date)
    },
  },
  setup() {
    return {
      ...useRouter(),
    }
  },
})
